import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "../css/Banner.module.css";

export default function Banner({ onLogout }) {
  const navigate = useNavigate();
  
  const user = JSON.parse(localStorage.getItem("user"));
  const userRol = user?.id_rol;

  const handleLogoutClick = () => {
    if (onLogout) onLogout();
  };

  let botones = [
    { label: "Home", path: "/home", image: "images/home-icon.png" },
    { label: "Ver Tabla", path: "/tabla" },
    { label: "Ver Gráficas", path: "/graficas" },
    { label: "Formulario", path: "/formulario" },
    { label: "Autorizacion", path: "/autorizacion" },
    { label: "Denominadores", path: "/denominadores" },
    { label: "Cerrar sesión", action: handleLogoutClick, image: "images/logout.png" },
  ];

  if (userRol === 4) {
    botones = botones.filter(btn => btn.label !== "Formulario");
  } else if (userRol === 1 || userRol === 2 ) {}
  else if (userRol === 6){
    botones = botones.filter(btn => btn.label !== "Autorizacion");
    botones = botones.filter(btn => btn.label !== "Denominadores");
  } else {
    botones = botones.filter(btn => btn.label !== "Home");
    botones = botones.filter(btn => btn.label !== "Ver Tabla");
    botones = botones.filter(btn => btn.label !== "Ver Gráficas");
    botones = botones.filter(btn => btn.label !== "Formulario");
    botones = botones.filter(btn => btn.label !== "Autorizacion");
    botones = botones.filter(btn => btn.label !== "Denominadores");
  }

  return (
    <Box className={styles.bannerContainer}>
      <Box className={styles.topSection}>
        <img
          src="images/sesanLogo.png"
          alt="Logo SESAN"
          className={styles.leftLogo}
        />

        <Typography variant="h5" className={styles.bannerTitle}>
          Protocolo interinstitucional para el abordaje de la desnutrición aguda en territorios de mayor carga de morbilidad o mortalidad
        </Typography>

        <img
          src="images/catieLogo.png"
          alt="Logo CATIE"
          className={styles.rightLogo}
        />
      </Box>

      <Box className={styles.buttonSection}>
        {botones.map((btn) => (
          <Button
            key={btn.label}
            variant="outlined"
            className={styles.navButton}
            onClick={() => btn.action ? btn.action() : navigate(btn.path)}
          >
            {btn.image ? (
              <img
                src={btn.image}
                alt={btn.label}
                className={styles.homeButtonImage}
              />
            ) : (
              btn.label
            )}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
